import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=133cbfab&scoped=true&"
import script from "./TabsBar.vue?vue&type=script&lang=js&"
export * from "./TabsBar.vue?vue&type=script&lang=js&"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=133cbfab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cbfab",
  null
  
)

export default component.exports